import React from 'react'

const UnFilledEclipseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <circle cx='12' cy='12' r='11' stroke='#D1D1D1' strokeWidth='2' />
    </svg>
  )
}

export default UnFilledEclipseIcon
